import React, { useEffect, useState } from "react";
import MyDataTable from "../../../../component/MyDataTable";
import httpRequest from "../../../../utils/Http";
import Select from "react-select";
import { toast } from "react-toastify";

const ReceivedReverseParts = ({ setReload, reloadList, warehouse_id }) => {
  const [partnerlist, setPartnerlist] = useState([]);
  const [formData, setFormData] = useState({ warehouse_id, partner_id: null });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    (async () => {
      const partners = await httpRequest(
        "getpartnerlist?is_active=1",
        {},
        "GET",
      );
      if (partners.status === true && partners.data) {
        setSelectedItems([]);
        setPartnerlist(
          partners.data["rows"].map((partner) => ({
            value: partner.partner_id,
            label: partner.display_name,
          })),
        );
      }
    })();
  }, []);

const handleQuantityChange = (row, qty) => {
  const quantity = Number(qty);

  if (quantity < 0 || quantity > row.total_shipped_quantity) return;

  setSelectedItems((prev) => {
    const groupKey = row.is_invoice+"_"+row.to_gst_id; // group by is_invoice
    const currentGroup = prev[groupKey] || [];

    const index = currentGroup.findIndex(
      (item) => item.part_id === row.part_id
    );

    // REMOVE if quantity = 0
    if (quantity === 0) {
      const updatedGroup = currentGroup.filter(
        (item) => item.part_id !== row.part_id
      );

      return {
        ...prev,
        [groupKey]: updatedGroup,
      };
    }

    // UPDATE if already exists
    if (index !== -1) {
      const updatedGroup = [...currentGroup];
      updatedGroup[index] = {
        ...updatedGroup[index],
        quantity,
      };

      return {
        ...prev,
        [groupKey]: updatedGroup,
      };
    }

    // ADD new item
    const newItem = {
      part_id: row.part_id,
      part_name: row.part_name,
      part_number: row.part_number,
      is_invoice: row.is_invoice,
      to_gst_number: row.to_gst_number,
      to_gst_id: row.to_gst_id,
      spare: row.spare,
      warehouse_id: formData.warehouse_id,
      partner_id: formData.partner_id,
      quantity,
    };

    return {
      ...prev,
      [groupKey]: [...currentGroup, newItem],
    };
  });
};

  const getInvoiceChallan = (is_invoice) => {
    return Number(is_invoice) === 1 ? 'Invoice' : 'Challan'
  }

  const generateChallan = (e) => {
    e.preventDefault();
    const confirm = window.confirm(
      "Are you sure you want to create challan/invoice?",
    );
    if (confirm) {
      console.log(formErrors);
      setSubmit(false);
      setFormErrors(validateForm(formData));
      setSubmit(true);
    }
  };

  const validateForm = (value) => {
    const errors = {};
    if (!value.warehouse_id) {
      errors.warehouse_id = "Central Warehouse is Required";
    }
    if (!value.partner_id) {
      errors.partner_id = "Partner is Required";
    }
    if (Object.values(selectedItems).flat().length === 0) {
      errors.checkbox = "Select at least one quantity";
    }
    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
       // console.log("h2");
        const data = await httpRequest(
          "generatechallansendtopartner",
          { data: selectedItems, warehouse_id: formData.warehouse_id, partner_id: formData.partner_id },
          "POST",
        );

        setSubmit(false);
        if (data.status === true && data.message) {
          setSelectedItems([]);
          toast.success(data.message);
          setReload(true);
        } else {
          toast.error(data.message);
        }
      }
    })();
  }, [isSubmit, formErrors, setReload, formData]);

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: <div className="word-wrap">Partner name</div>,
      selector: (row) => row.partner_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Partner Gst Number</div>,
      selector: (row) => row.to_gst_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Invoice/Challan</div>,
      selector: (row) => getInvoiceChallan(row.is_invoice),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Appliance</div>,
      selector: (row) => `${row.appliance_name}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Part Name / Number</div>,
      selector: (row) =>
        `${row.part_name} / ${row.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Total Qty In Warehouse</div>,
      selector: (row) => `${row.total_shipped_quantity}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Select Qty</div>,
      cell: (row) => (
        <input
          disabled={formData.partner_id && !reloadList ? false : true}
          type="number"
          min={0}
          max={row.total_shipped_quantity}
          value={
            selectedItems[row.is_invoice + "_" + row.to_gst_id]
              ?.find((item) => item.part_id === row.part_id)
              ?.quantity || ""
          }
          onChange={(e) => handleQuantityChange(row, e.target.value)}
          className="form-control"
          style={{ width: "80px" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    }
  ];

  useEffect(() => {
    if (formData.partner_id) {
      setFormData({ partner_id: formData.partner_id, warehouse_id });
      setSelectedItems([]);
      setReload(true);
    }
  }, [formData.partner_id, setReload, warehouse_id]);

    const totalSelectedQty = Object.values(selectedItems)
    .flat()
    .reduce((sum, item) => sum + (item.quantity || 0), 0);

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Partner *<span style={{ color: "red" }}></span>
                    </label>
                    <Select
                      name="partner_id"
                      value={
                        partnerlist.find(
                          (option) => option.value === formData.partner_id,
                        ) || null
                      }
                      options={partnerlist}
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          partner_id: val.value,
                        });
                        setSelectedItems([]);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4" style={{ marginTop: "14px" }}>
                  <div className="col-md-12">
                    <button
                      type="submit"
                      id="submit"
                      className="btn btn-primary"
                      disabled={Object.values(selectedItems).flat().length === 0}
                      onClick={(e) => {
                        generateChallan(e);
                      }}
                    >
                      Generate Challan (Total Qty: {totalSelectedQty})
                    </button>
                  </div>
                </div>
              </div>

              <MyDataTable
                reloadList={reloadList}
                columns={columns}
                getDataListURL={`getreversepartreceivedbywarehouse?warehouse_id=${warehouse_id}&partner_id=${formData.partner_id}`}
                setReload={setReload}
                exportName={"partlist"}

              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReceivedReverseParts;
